import { Link } from 'react-router-dom';
import { 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin, 
  FaYoutube,
  FaEnvelope,
  FaMapMarkerAlt,
  FaHeart,
  FaMobileAlt
} from 'react-icons/fa';
import { showInstallPrompt } from './InstallAppPrompt';
import './Footer.css';

const Footer = () => {
  const handleDownloadApp = (e) => {
    e.preventDefault();
    showInstallPrompt();
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section brand-section">
            <div className="footer-brand">
              <div className="footer-logo">
                <span className="logo-text">
                  UBSA<span className="logo-accent">APP</span>
                </span>
                <span className="logo-subtext">Book&Stay</span>
              </div>
            </div>
            <p className="footer-description">
              We help you find comfortable and trusted stays, without the stress. 
              Your perfect accommodation is just a click away.
            </p>
            
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span className="contact-text">info.ubsaaap@atozasindia.in</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span className="contact-text">
                  Developed by AtoZ Auto<br />
                  F-18, PH VI AYA NAGAR EXTN., NEW DELHI, Delhi, India - 110047
                </span>
              </div>
            </div>
            
            <div className="social-section">
              <h5 className="social-title">Follow Us</h5>
              <div className="social-links">
                <a href="#" aria-label="Facebook" className="social-link">
                  <FaFacebook />
                </a>
                <a href="#" aria-label="Twitter" className="social-link">
                  <FaTwitter />
                </a>
                <a href="#" aria-label="Instagram" className="social-link">
                  <FaInstagram />
                </a>
                <a href="#" aria-label="LinkedIn" className="social-link">
                  <FaLinkedin />
                </a>
                <a href="#" aria-label="YouTube" className="social-link">
                  <FaYoutube />
                </a>
              </div>
            </div>

            <a href="#download-app" className="footer-download-app" onClick={handleDownloadApp} aria-label="Download app">
              <FaMobileAlt className="footer-download-icon" /> Download app
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>
                &copy; {new Date().getFullYear()} UBSAAPP. All rights reserved. 
                <span className="made-with-love">
                  Made with <FaHeart className="heart-icon" /> in India
                </span>
              </p>
            </div>
            <div className="footer-legal">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/cookies">Cookie Policy</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;







